import React, { useState, useEffect } from 'react';

import { Modal } from '../../themes/nzf_2022';
import CloseModal from './close-button';

const handleGoToCart = (cartPageUrl) => {
  window.location.href = cartPageUrl;
};

const TicketAddedToCart = ({ eventName, session, numTickets, goToCartBtnText, cartPageUrl, continueBtnText, cartExpiryText, closeModal }) => {
  return (
    <Modal
      onCloseCB={ closeModal }
      parsedContent={ (
        <div className='flex flex-column flex-ai-center w-11/12 mx-auto'>
          <CloseModal />
          <h3 className='w-8/12 sm+:w-11/12 text-center u-text-no-transform mx-auto mb-5'>
            Ticket
            { numTickets > 1 && ('s') }
            {' '}
            added to cart
          </h3>
            {cartExpiryText &&(
                <p className='mb-5'>{ cartExpiryText }</p>
            )}
          {cartPageUrl && (
          <button
            type='button'
            className='btn btn--default btn--large w-11/12 mx-auto px-12 text-sm sm+:max-w-8/12 whitespace-normal mb-5'
            onClick={ () => handleGoToCart(cartPageUrl) }
          >
            { goToCartBtnText }
            {' '}
          </button>
          )}
          <button
            type='button'
            className='btn btn--hollow border-black border-solid btn--large w-11/12 mx-auto px-12 text-sm sm+:max-w-8/12 whitespace-normal mb-24'
            onClick={ () => closeModal() }
          >
            { continueBtnText }
          </button>
        </div>
    ) }
    />
  );
};

export default TicketAddedToCart;
